import { Stack } from "@mui/material";
import { useBoundStore } from "useStore";
import FilterChip from "./utils/FilterChip";

export default function KamFilterChip() {
  const selectedKam = useBoundStore((state) => state.productMasterSelectedKam);
  const resetSelectedKam = useBoundStore(
    (state) => state.clearProductMasterSelectedKam,
  );

  if (selectedKam.length === 0) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      <FilterChip
        filterName="KAM"
        title={selectedKam}
        onDelete={() => resetSelectedKam()}
      />
    </Stack>
  );
}
